import TRANSLATE_EL from './el/translations.json';
import TRANSLATE_EN from './en/translations.json';
import TRANSLATE_DE from './de/translations.json';
import TRANSLATE_TR from './tr/translations.json';

export const translations = {
  el: { translation: TRANSLATE_EL },
  en: { translation: TRANSLATE_EN },
  de: { translation: TRANSLATE_DE },
  tr: { translation: TRANSLATE_TR },
};
